export const TAG_ID = {
    NONE: 0,
    LOGIN: 1,
    HEADER: 2,
    PRELOAD: 3,
    ACCOUNT: 4,
    ERRORS: 5,
    FOOTER: 6,
    REGISTRATION: 7,
    REGISTRATION_TEMPLATES: 36,
    HOW_HEARD: 13,
    EMAILS: 14,
    PROFILE: 15,
    SURVEYS: 16,
    INTRO_ADVANTAGES: 17,
    VERIFICATION: 18,
    WALLET: 19,
    UNSUBSCRIBE: 20,
    SUPPORT: 21,
    SURVEY_END: 22,
    CALIFORNIA_PRIVACY: 23,
    PRIVACY_POLICY: 24,
    TERMS_AND_CONDITIONS: 25,
    COMPENSATION_PROVISIONS: 26,
    COOKIE_POLICY: 27,
    ABOUT_US: 29,
    CONTACT_US: 28,
    YOTI: 32,
    WALLET_INTRO: 33,
    SCREENING_POLICY: 34,
    AFFILIATES: 38,
    CCPA: 40,
    NM_DASHBOARD: 41,
    TAX_FAQ: 42,
    PAGES: 43,
    IDENTITY: 44,
    SUBPANEL: 49,
    SELECT_OPINION: 58,
    SELECT_OPINION_FAQ: 59,
} as const;
